import { render, staticRenderFns } from "./addFeedback.vue?vue&type=template&id=16480774&scoped=true&"
import script from "./addFeedback.vue?vue&type=script&lang=js&"
export * from "./addFeedback.vue?vue&type=script&lang=js&"
import style0 from "./addFeedback.vue?vue&type=style&index=0&id=16480774&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16480774",
  null
  
)

export default component.exports